export const googleMapApiKey = import.meta.env.VITE_GOOGLE_MAP_API_KEY || ''
